import React, { Component } from "react";
import Pelayanan from "./pelayanaObat";
import PelayananPx from "./PelayananPx";
import { DetilPxContext } from "../../context";

export default class ContainerPelayanan extends Component {
  state = {
    detilPx: {},
    selected: {},
    onService: false
  };

  changeDetilPx = data => {
    this.setState({
      detilPx: data,
      onService: true
    });
  };

  selectedData = data => {
    this.setState({
      selected: data,
    });
  };

  static getDerivedStateFromProps(props) {
    // console.log(props);
    if (props.history.location.pathname === '/PelayananObatList') {
      return { onService: false };
    } else {
      return null;
    }
  }

  render() {
    const onService = this.state.onService;
    return (
      <DetilPxContext.Provider
        value={{ data: this.state.detilPx, selected : this.state.selected ,changeDetilPx: this.changeDetilPx, changeSelected: this.selectedData }}
      >
        {onService ? (
          <PelayananPx {...this.props} />
        ) : (
          <Pelayanan {...this.props}></Pelayanan>
        )}
      </DetilPxContext.Provider>
    );
  }
}
